var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',[_vm._v("\n  Loading...\n")]):_c('router-view',{key:_vm.$route.fullPath,attrs:{"user":_vm.user,"myUsername":_vm.myUsername},on:{"logout":_vm.logout,"change-user":_vm.setUser}})}
var staticRenderFns = []

export { render, staticRenderFns }